import React from "react";
import Parser from "html-react-parser";
import { v4 as generateUUID } from "uuid";
import { Header, Paragraph } from "@tvg/design-system/web";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import { RichText, RichTextInlineComp, Seo } from "../../types";
import {
  RenderRichTextInlineComp,
  RenderRichTextParagraph
} from "../richTextEditorResolver";

import {
  PromosSeoContainerWrapper,
  PromosSeoContainer
} from "./styled-components";

export interface SeoProps {
  content: Seo;
}

interface Content {
  type: string;
  blok: {
    type: string;
  };
}

const PromosSeoContent = ({
  content = {
    title: "",
    description: ""
  }
}: SeoProps) => {
  const { title, description } = content;

  if (!title && !description) return null;

  let simpleDescription = null;

  const listOfContents: Content[] = [];
  if (typeof description !== "string") {
    description.content.forEach((blok) =>
      listOfContents.push(blok as unknown as Content)
    );
  } else {
    simpleDescription = (
      <Paragraph fontSize={14} qaLabel="simple-description-paragraph">
        <>{Parser(description)}</>
      </Paragraph>
    );
  }
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

  return (
    <PromosSeoContainerWrapper isMobile={isMobile}>
      <PromosSeoContainer
        data-qa-label="promosSeoContainer"
        isMobile={isMobile}
      >
        <Header tag="h3" color="--fd-colors-content-strong">
          {title}
        </Header>
        {simpleDescription}
        {listOfContents.map((blok) => {
          if (blok.type === "paragraph") {
            const actualText = RenderRichTextParagraph(
              blok as unknown as RichText
            );
            const uniqueId = generateUUID();
            return (
              <Paragraph
                key={uniqueId}
                fontSize="s"
                qaLabel="promo-seo-paragraph"
                marginTop="var(--fd-space-space-4)"
              >
                <>{Parser(actualText as string)}</>
              </Paragraph>
            );
          }
          return RenderRichTextInlineComp(
            blok as unknown as RichTextInlineComp
          );
        })}
      </PromosSeoContainer>
    </PromosSeoContainerWrapper>
  );
};

export default PromosSeoContent;
